var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 312,
    height: 312,
    viewBox: "0 0 312 312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M324.891,362.534c0,18.115-9.978,32.8-22.285,32.8s-22.285-14.686-22.285-32.8,9.977-32.8,22.285-32.8S324.891,344.417,324.891,362.534Z",
    transform: "translate(-280.321 -329.731)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M409.153,362.534c0,18.115-6.35,32.8-14.181,32.8s-14.184-14.686-14.184-32.8,6.35-32.8,14.184-32.8S409.153,344.417,409.153,362.534Z",
    transform: "translate(-380.788 -329.731)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M302.577,378.716c0-26.137,9.08-47.326,20.283-47.326s20.281,21.188,20.281,47.326c0,1.436-.031,2.853-.085,4.256h72.262c-.039-1.4-.063-2.821-.063-4.256,0-26.137,6.616-47.326,14.774-47.326,5.451,0,10.21,9.467,12.77,23.541v-38.6a7.535,7.535,0,0,0-6.157-7.41l-.354-.069c-5.008-1-14.022-10.516-28.045-22.535S381.7,273.3,381.7,273.3H255.182a10.8,10.8,0,0,0-6.605,2.253l-43.154,33.3s-38.561,7.512-47.074,16.026-7.513,58.092-7.513,58.092H302.663C302.609,381.569,302.577,380.152,302.577,378.716Z",
    transform: "translate(-150.799 -273.299)",
    fill: "#c6ff00",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M305.257,308.285h74.117s10.516-3.505,7.512-16.526c-1.02-4.418-22.036-14.524-25.041-14.524H325.788Z",
    transform: "translate(-305.257 -277.235)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526",
    transform: "translate(-1425 -967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M156,0A156,156,0,1,1,0,156,156,156,0,0,1,156,0Z",
    transform: "translate(1425 967)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(1284.201 809.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car",
    transform: "translate(150.799 273.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M203.955,303.247h-.616a3.9,3.9,0,0,1-3.7-5.11c.775-2.4,2.1-4.824,4.311-5.193,4.579-.764,17.172,3.053,17.172,5.724s0,3.816-1.526,3.816h-9.539l-7.632,8.4-.163-.134a3.522,3.522,0,0,1-.01-5.393A7.985,7.985,0,0,0,203.955,303.247Z",
    transform: "translate(-143.756 -270.469)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M278.719,371.6H405.407s18.316-12.211,14.5-44.265-24.421-10.684-32.053,10.685H331.378s-12.211-24.422-32.053-21.369S278.719,371.6,278.719,371.6Z",
    transform: "translate(-132.281 -267.843)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M311.548,362.534c0-9.412-2.7-17.893-7.011-23.874v-8.929H289.263c-12.307,0-22.285,14.686-22.285,32.8s9.978,32.8,22.285,32.8h15.275v-8.928C308.852,380.426,311.548,371.945,311.548,362.534Z",
    transform: "translate(-133.98 -265.13)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "translate(148.272 64.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M324.891,362.534c0,18.115-9.978,32.8-22.285,32.8s-22.285-14.686-22.285-32.8,9.977-32.8,22.285-32.8S324.891,344.417,324.891,362.534Z",
    transform: "translate(-280.321 -329.731)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M324.891,362.534c0,18.115-9.978,32.8-22.285,32.8s-22.285-14.686-22.285-32.8,9.977-32.8,22.285-32.8S324.891,344.417,324.891,362.534Z",
    transform: "translate(-280.321 -329.731)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M324.891,362.534c0,18.115-9.978,32.8-22.285,32.8s-22.285-14.686-22.285-32.8,9.977-32.8,22.285-32.8S324.891,344.417,324.891,362.534Z",
    transform: "translate(-280.321 -329.731)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M190.142,329.731H175.706c-11.632,0-21.061,14.686-21.061,32.8s9.429,32.8,21.061,32.8h14.436c11.632,0,21.063-14.686,21.063-32.8S201.774,329.731,190.142,329.731Z",
    transform: "translate(-150.243 -265.13)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M319.814,361.7c0,14.452-7.96,26.167-17.778,26.167s-17.778-11.716-17.778-26.167,7.96-26.169,17.778-26.169S319.814,347.243,319.814,361.7Z",
    transform: "translate(-131.479 -264.291)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M401.138,362.534c0-9.412-1.717-17.893-4.461-23.874v-8.929H383.191c-7.833,0-14.183,14.686-14.183,32.8s6.35,32.8,14.183,32.8h13.487v-8.928C399.421,380.426,401.138,371.945,401.138,362.534Z",
    transform: "translate(-119.21 -265.13)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    transform: "translate(263.284 64.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M409.153,362.534c0,18.115-6.35,32.8-14.181,32.8s-14.184-14.686-14.184-32.8,6.35-32.8,14.184-32.8S409.153,344.417,409.153,362.534Z",
    transform: "translate(-380.788 -329.731)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M409.153,362.534c0,18.115-6.35,32.8-14.181,32.8s-14.184-14.686-14.184-32.8,6.35-32.8,14.184-32.8S409.153,344.417,409.153,362.534Z",
    transform: "translate(-380.788 -329.731)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M409.153,362.534c0,18.115-6.35,32.8-14.181,32.8s-14.184-14.686-14.184-32.8,6.35-32.8,14.184-32.8S409.153,344.417,409.153,362.534Z",
    transform: "translate(-380.788 -329.731)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M405.921,361.7c0,14.452-5.064,26.167-11.313,26.167s-11.315-11.716-11.315-26.167,5.066-26.169,11.315-26.169S405.921,347.243,405.921,361.7Z",
    transform: "translate(-117.142 -264.291)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M302.577,378.716c0-26.137,9.08-47.326,20.283-47.326s20.281,21.188,20.281,47.326c0,1.436-.031,2.853-.085,4.256h72.262c-.039-1.4-.063-2.821-.063-4.256,0-26.137,6.616-47.326,14.774-47.326,5.451,0,10.21,9.467,12.77,23.541v-38.6a7.535,7.535,0,0,0-6.157-7.41l-.354-.069c-5.008-1-14.022-10.516-28.045-22.535S381.7,273.3,381.7,273.3H255.182a10.8,10.8,0,0,0-6.605,2.253l-43.154,33.3s-38.561,7.512-47.074,16.026-7.513,58.092-7.513,58.092H302.663C302.609,381.569,302.577,380.152,302.577,378.716Z",
    transform: "translate(-150.799 -273.299)",
    fill: "#00b1ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M327.616,308.854l6.7-35.555H255.182a10.808,10.808,0,0,0-6.605,2.252l-43.154,33.3s-38.561,7.512-47.074,16.026-7.513,58.092-7.513,58.092H286.311c.975-26.767,7.11-39.5,7.11-39.5H256.026C285.026,312.182,327.616,308.854,327.616,308.854Z",
    transform: "translate(-150.799 -273.299)",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M302.577,378.716c0-26.137,9.08-47.326,20.283-47.326s20.281,21.188,20.281,47.326c0,1.436-.031,2.853-.085,4.256h72.262c-.039-1.4-.063-2.821-.063-4.256,0-26.137,6.616-47.326,14.774-47.326,5.451,0,10.21,9.467,12.77,23.541v-38.6a7.535,7.535,0,0,0-6.157-7.41l-.354-.069c-5.008-1-14.022-10.516-28.045-22.535S381.7,273.3,381.7,273.3H255.182a10.8,10.8,0,0,0-6.605,2.253l-43.154,33.3s-38.561,7.512-47.074,16.026-7.513,58.092-7.513,58.092H302.663C302.609,381.569,302.577,380.152,302.577,378.716Z",
    transform: "translate(-150.799 -273.299)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M343.746,273.3H248.275a10.8,10.8,0,0,0-6.605,2.253l-43.154,33.3H320.71Z",
    transform: "translate(-143.892 -273.299)",
    fill: "#086994",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422",
    transform: "translate(113.216 48.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M286.331,316.06c-6.873.087-18.9.544-24.112,2.63A96.375,96.375,0,0,0,249.7,324.7h24.539Z",
    transform: "translate(-249.698 -316.059)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M275.739,330.739v-4.508H249.7l4.716,4.355a1.047,1.047,0,0,0-.208.153Z",
    transform: "translate(-249.698 -314.586)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M274.634,325.7v6.55a6.619,6.619,0,0,0,5.008-3.044c2.5-4.007,8.14-13.148,8.14-13.148Z",
    transform: "translate(-246.088 -316.059)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(2.628 53.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M160.439,330.586l4.716-4.355H154.039c-.347,1.409-.661,2.918-.944,4.508h7.553A1.022,1.022,0,0,0,160.439,330.586Z",
    transform: "translate(-153.095 -318.95)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M156.492,319.871a21.536,21.536,0,0,0-1.833,4.276h10.27A88.522,88.522,0,0,0,156.492,319.871Z",
    transform: "translate(-152.869 -319.871)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425",
    transform: "translate(176.818 4.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M305.257,308.285h74.117s10.516-3.505,7.512-16.526c-1.02-4.418-22.036-14.524-25.041-14.524H325.788Z",
    transform: "translate(-305.257 -277.235)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M305.257,308.285h74.117s10.516-3.505,7.512-16.526c-1.02-4.418-22.036-14.524-25.041-14.524H325.788Z",
    transform: "translate(-305.257 -277.235)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M305.257,308.285h74.117s10.516-3.505,7.512-16.526c-1.02-4.418-22.036-14.524-25.041-14.524H325.788Z",
    transform: "translate(-305.257 -277.235)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M238.748,277.235l-40.233,31.049H320.708l20.117-31.049Z",
    transform: "translate(-143.892 -272.729)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M165.268,324.481V335l7.512,5.508h60.6L247.4,334.5V324.481Z",
    transform: "translate(-148.705 -265.889)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426",
    transform: "translate(16.563 58.592)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 2.8,
    height: 2.8,
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 2.8,
    height: 2.8,
    transform: "translate(3.096 3.097)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 2.8,
    height: 2.8,
    transform: "translate(6.192 6.192)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 2.8,
    height: 2.8,
    transform: "translate(9.289 9.289)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 2.8,
    height: 2.8,
    transform: "translate(78.773)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 2.8,
    height: 2.8,
    transform: "translate(75.677 3.097)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 2.8,
    height: 2.8,
    transform: "translate(72.581 6.192)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 2.8,
    height: 2.8,
    transform: "translate(69.485 9.289)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 2.8,
    height: 2.8,
    transform: "translate(13.589 9.289)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 2.8,
    height: 2.8,
    transform: "translate(17.888 9.289)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 2.8,
    height: 2.8,
    transform: "translate(22.188 9.289)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 2.8,
    height: 2.8,
    transform: "translate(26.487 9.289)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 2.8,
    height: 2.8,
    transform: "translate(30.787 9.289)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 2.8,
    height: 2.8,
    transform: "translate(35.087 9.289)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 2.8,
    height: 2.8,
    transform: "translate(39.387 9.289)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 2.8,
    height: 2.8,
    transform: "translate(43.687 9.289)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 2.8,
    height: 2.8,
    transform: "translate(47.986 9.289)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 2.8,
    height: 2.8,
    transform: "translate(52.286 9.289)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 2.8,
    height: 2.8,
    transform: "translate(56.586 9.289)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 2.8,
    height: 2.8,
    transform: "translate(60.886 9.289)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 2.8,
    height: 2.8,
    transform: "translate(65.185 9.289)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M278.525,351.944h-124.7l-1.67-13.362c-.765,7.343-1.114,15.17-1.264,21.595l.43,1.784,2.5-5.008h10.7l-6.689,5.509h99.157l-3.542-5.509h25.076l7.012,4.007h5.007v-25.54Z",
    transform: "translate(-150.786 -264.306)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M328.622,303.247h-.616a3.9,3.9,0,0,1-3.7-5.11c.775-2.4,2.1-4.824,4.311-5.193,4.579-.764,17.172,3.053,17.172,5.724s0,3.816-1.526,3.816h-9.539l-7.632,8.4-.164-.134a3.523,3.523,0,0,1-.01-5.393A7.989,7.989,0,0,0,328.622,303.247Z",
    transform: "translate(-125.708 -270.469)",
    fill: "#00b1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M349.084,308.285h4.18c-.443-6.141-2.195-19.675-9.075-31.05H340C342.416,282.471,348.143,295.967,349.084,308.285Z",
    transform: "translate(-123.41 -272.729)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M277.244,284.889l1.526,4.2a9.857,9.857,0,0,0-3.052,6.869v11.554h-9.4l7.868-22.619Zm-43.882,5.724c-6.446,3.922-16.179,12.574-20.9,16.9h31.378L260.072,282.6l-10.684.762A67.249,67.249,0,0,0,233.362,290.612Zm64.869-3.053-3.815-.764h-5.343l-1.526,1.527s3.815.381,4.2,2.671a58.283,58.283,0,0,1,.381,6.869H294.8s0-4.2,1.908-6.105a35.9,35.9,0,0,1,3.434-3.053Z",
    transform: "translate(-141.872 -271.953)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M326.926,309.853l.164.134,7.631-8.4h9.54c1.26,0,1.477-.8,1.515-2.577H324.161a3.879,3.879,0,0,0,3.838,3.34h.616a8.011,8.011,0,0,1-1.7,2.105A3.524,3.524,0,0,0,326.926,309.853Z",
    transform: "translate(-125.702 -269.576)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 8.59,
    height: 1.841,
    transform: "translate(216.189 44.775)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 8.59,
    height: 1.841,
    transform: "translate(254.843 44.775)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M382.153,305.98S388.367,310.2,391.97,325c0,0-15.339,1.841-15.339,44.175",
    transform: "translate(-118.106 -268.568)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427",
    transform: "translate(0.001 102.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M383.171,362.793H318.784q.041,1.472.043,2.967c0,1.436-.031,2.853-.085,4.256h72.262c-.039-1.4-.063-2.821-.063-4.256,0-.1,0-.2,0-.294Z",
    transform: "translate(-126.487 -362.793)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M302.577,365.76c0-1,.017-1.986.043-2.967H150.808c-.029,4.405.027,7.223.027,7.223H302.663C302.609,368.613,302.577,367.2,302.577,365.76Z",
    transform: "translate(-150.8 -362.793)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M404.077,309.2a4.4,4.4,0,0,0-3.864,6.508l6.556,12.018V311.136a7.529,7.529,0,0,0-.28-1.936l-.063,0Z",
    transform: "translate(-114.77 -268.102)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M352.052,309.932s13.737,19.842,0,53.423",
    transform: "translate(-121.664 -267.996)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_8634652061552642237",
    "data-name": 8634652061552642000,
    transform: "translate(1546.042 993.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435",
    transform: "translate(32.426 31.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1254-2",
    "data-name": "Path 1254",
    d: "M17.447,48.259A2.448,2.448,0,0,1,15,45.812V16.447a2.447,2.447,0,0,1,4.894,0V45.812A2.448,2.448,0,0,1,17.447,48.259Z",
    transform: "translate(-15 -14)",
    fill: "#00b1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(10.403 46.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M8.447,37.129A2.448,2.448,0,0,1,6,34.682V22.447a2.447,2.447,0,0,1,4.894,0V34.682A2.448,2.448,0,0,1,8.447,37.129Z",
    transform: "translate(-6 -20)",
    fill: "#00b1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(54.45 46.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M26.447,32.235A2.448,2.448,0,0,1,24,29.788V22.447a2.447,2.447,0,0,1,4.894,0v7.341A2.448,2.448,0,0,1,26.447,32.235Z",
    transform: "translate(-24 -20)",
    fill: "#00b1ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M37.548,11.5a1.654,1.654,0,0,0-1.578-1.143h0l-7.921.017L25.618,2.837a1.66,1.66,0,0,0-3.162,0l-2.427,7.544-7.919-.02h0a1.656,1.656,0,0,0-.971,3L17.555,18l-2.469,7.525a1.661,1.661,0,0,0,2.56,1.857l6.392-4.674,6.394,4.674a1.661,1.661,0,0,0,2.557-1.86L30.522,18l6.421-4.637A1.656,1.656,0,0,0,37.548,11.5Z",
    transform: "translate(10.836 0)",
    fill: "#00b1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M23.017,17.335a1.226,1.226,0,0,0-1.17-.847h0l-5.863.012-1.8-5.582a1.229,1.229,0,0,0-2.339,0L10.05,16.5l-5.861-.012h0a1.226,1.226,0,0,0-.719,2.222l4.75,3.431-1.828,5.57a1.229,1.229,0,0,0,1.167,1.613,1.216,1.216,0,0,0,.724-.237l4.733-3.46,4.733,3.458a1.225,1.225,0,0,0,1.446,0,1.231,1.231,0,0,0,.445-1.378l-1.828-5.57,4.752-3.433A1.217,1.217,0,0,0,23.017,17.335Z",
    transform: "translate(0 12.128)",
    fill: "#00b1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M40.951,17.335a1.226,1.226,0,0,0-1.17-.847h0l-5.863.012-1.8-5.582a1.229,1.229,0,0,0-2.339,0l-1.8,5.584-5.863-.012h0A1.226,1.226,0,0,0,21.4,18.71l4.752,3.431-1.828,5.57a1.229,1.229,0,0,0,1.167,1.613,1.216,1.216,0,0,0,.724-.237l4.735-3.46,4.733,3.458a1.225,1.225,0,0,0,1.446,0,1.231,1.231,0,0,0,.445-1.378l-1.828-5.57L40.5,18.706A1.219,1.219,0,0,0,40.951,17.335Z",
    transform: "translate(25.947 12.128)",
    fill: "#00b1ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.e76d88d05e830779e878625952b52fdf.svg";
export { ForwardRef as ReactComponent };